import { Container, Row, Col } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { useState, useEffect } from "react";
import { Vendorlist } from "../../env/action";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import company2 from "../../assets/company7.png";
import company3 from "../../assets/company8.png";
import company4 from "../../assets/company9.png";
import company5 from "../../assets/company10.png";
import company6 from "../../assets/company11.png";

const leadersData = [
  {
    name: "Jan Ingenhousz",
    image: company2,
  },
  {
    name: "Jan Ingenhousz",
    image: company3,
  },
  {
    name: "Jan Ingenhousz",
    image: company4,
  },
  {
    name: "Jan Ingenhousz",
    image: company5,
  },
  {
    name: "Jan Ingenhousz",
    image: company6,
  },
];

const OurSupportedPartnes = () => {
  const [loading, setLoading] = useState(true);
  const [vendor, setVendor] = useState([]);

  useEffect(() => {
    Vendorlist((res) => {
      if (res.status === 1) {
        setVendor(res.data);
        console.log(res.data, "-------dataa");
      } else {
        console.log("No vendor found");
      }
    });
  }, []);

  const staffSliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 4 } },
      { breakpoint: 992, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 576, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <Container className="mt-4 py-5">
      <div>
        <p className="fs-3 fw-bolder">Our Supported Partnes</p>
      </div>
      <Slider {...staffSliderSettings}>
        {vendor.map((partner, index) => (
          <div key={index} className="px-2">
            <Card className="h-100 text-center shadow-sm border-0 rounded-3">
              <Card.Img
                variant="top"
                src={partner.vendor_logo}
                style={{
                  height: "180px",
                  objectFit: "cover",
                  // padding: "1rem",
                }}
              />
              <Card.Body className="p-1">
                <Card.Title className="fs-6 fw-bold text-uppercase">
                  {partner.company_name}
                </Card.Title>
              </Card.Body>
            </Card>
          </div>
        ))}
      </Slider>
    </Container>
  );
};

export default OurSupportedPartnes;
